import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Col, Row } from 'react-flexbox-grid';
import Button from '@saucelabs/sl-component-buttons';
import { records as jobsRecords } from '@saucelabs/sl-module-jobs';
import { JobCard } from '@saucelabs/sl-component-job-card';
import { GroupByDate } from '@saucelabs/sl-component-group-by-date';
import { actions as notifications } from '@saucelabs/sl-container-notifications';
import { useDispatch } from 'react-redux';

import RenderResults from './RenderResults';
import { JOB_TYPES, NAVIGATION_EVENTS, trackEvent } from './../tracking';
import Styles from './RdcJobs.styles';
import ListStyles from './List.styles';

const RdcJobs = ({ jobs, newerAvailable, olderAvailable, onClickNewer, onClickOlder }) => {
  const dispatch = useDispatch();

  return (
    <Row>
      <Col xs={12}>
        <div className={ListStyles.list}>
          <RenderResults size={jobs.size}>
            <GroupByDate datePath={(item) => item.props.job.get('start_time')}>
              {jobs.map((job) => (
                <JobCard
                  key={job.id}
                  job={job}
                  onClick={(event) => {
                    if (job.isRunning()) {
                      event.preventDefault();
                      dispatch(notifications.notifyWarning('Please wait until this job is finished', 'Test Report is in Progress', false));
                      trackEvent(
                        NAVIGATION_EVENTS.VIEW_RUNNING_JOB,
                        { type: JOB_TYPES.RDC },
                      );
                    }
                    trackEvent(
                      NAVIGATION_EVENTS.VIEW_JOB_DETAILS,
                      { type: JOB_TYPES.RDC },
                    );
                  }}
                />
              ))}
            </GroupByDate>
          </RenderResults>
          <div className={Styles['button-wrapper']}>
            <Button
              category="primary"
              className={Styles.button}
              disabled={!newerAvailable}
              onClick={onClickNewer}
            >
              Newer
            </Button>
            <Button
              category="primary"
              className={Styles.button}
              disabled={!olderAvailable}
              onClick={onClickOlder}
            >
              Older
            </Button>
          </div>
        </div>
      </Col>
    </Row>
  );
};

RdcJobs.propTypes = {
  jobs: ImmutablePropTypes.listOf(
    ImmutablePropTypes.recordOf(jobsRecords.JobRecordClass).isRequired,
  ).isRequired,
  newerAvailable: PropTypes.bool.isRequired,
  olderAvailable: PropTypes.bool.isRequired,
  onClickNewer: PropTypes.func.isRequired,
  onClickOlder: PropTypes.func.isRequired,
};

export default RdcJobs;
